// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertInstrumentLookupTemplate from '@front/templates/CreateAlertInstrumentLookupTemplate.html';
import { ContainerControl } from '@front/controls/elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class CreateAlertInstrumentLookup extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'CreateAlertInstrumentLookup';
    }
    oninit() {
        super.oninit();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void this.set('label', Resources.getResource('screen.Alerts.Label.Symbol'));
    }
}
ContainerControl.extendWith(CreateAlertInstrumentLookup, {
    template: CreateAlertInstrumentLookupTemplate,
    data: function () {
        return {
            label: '',
            isSymbolInfoOpened: false,
            instrument: null,
            account: null,
            width: 198
        };
    }
});
